var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.editable)?_c('v-text-field',{model:{value:(_vm.inputText),callback:function ($$v) {_vm.inputText=$$v},expression:"inputText"}}):_c('div',[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }